import { lazy } from "react";

export const LazyReferralAdoptionNudge = lazy(() =>
  import(
    /* webpackChunkName: "referral-adoption-nudge" */ "@faire/deprecated-retailer-visitor-shared/features/Nudges/ReferralAdoptionNudges/ReferralAdoptionNudge"
  ).then((m) => ({ default: m.ReferralAdoptionNudge }))
);
